module.exports = __webpack_public_path__ + "assets/images/mastery-change-down-icon.3b1869fb6df6d7fd8990068dfacc85da.svg";